var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',_vm._g(_vm._b({class:{ 'disabled-link': _vm.disabled }},'router-link',{ ..._vm.$attrs, to: _setup.to },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }